import { For } from 'solid-js';
import { toasts, toast } from '../lib/toast.js';

export default function Toasts() {
  return (
    <div class="toast-area">
      <For each={toasts()}>
        {(t) => (
          <div class={`toast ${t.kind}`} onClick={() => toast.dismiss(t.id)} role="alert">
            {t.message}
          </div>
        )}
      </For>
    </div>
  );
}
